var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgObject = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.5 6a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-13a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3zm-8.219 2c-1.291 0-1.703.372-1.703 1.53v1.016c0 .703-.422 1.07-1.578.984v.94c1.156-.087 1.578.281 1.578.989v1.012c0 1.157.412 1.529 1.703 1.529H11v-.726h-.527c-.739 0-.885-.16-.885-.935v-1.225c0-.63-.518-1.049-1.503-1.076v-.076c.985-.027 1.503-.445 1.503-1.076V9.66c0-.776.146-.935.885-.935H11V8zM13 8.726h.527c.739 0 .885.16.885.935v1.225c0 .63.518 1.049 1.503 1.076v.076c-.985.027-1.503.445-1.503 1.076v1.225c0 .776-.146.935-.885.935H13V16h.719c1.291 0 1.703-.372 1.703-1.53v-1.01c0-.708.422-1.075 1.578-.99v-.939c-1.156.087-1.578-.28-1.578-.984V9.529C15.422 8.372 15.01 8 13.719 8H13z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgObject);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/object.1535fddf.svg";